import { Component, AfterViewInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { environment as params } from './../environments/environment';
import { GtmService } from './core/services/utilities/gtm.service';
declare let window: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements AfterViewInit {
  private gaEnable = false;
  constructor(
    private router: Router,
    private _gtm: GtmService,
  ) {
    this.cssDinamico();
    this.developerMode();
  }

  ngAfterViewInit(): void {

    // console.log('After Ruta actual:', this.router.url);

    // //Prueba de datos
    //  (<any>window).push({
    //   'event': 'Pageview',
    //   'pagePath': 'https://www.example.com/something/contact-us',
    //   'pageTitle': 'Contact us' //some arbitrary name for the page/state
    //  });

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        // console.log('Ruta actual:', event.urlAfterRedirects);
        this.cssDinamico();
        this.sendVirtualPage(event);
      }
    });

    // console.log('DATOS: GTM', window.dataLayer);


  }

  sendVirtualPage(event){
    this._gtm.sendVirtualPage(event);
  }

  cssDinamico() {
    if (this.router.url.includes('seguros')) {
    } else {
    //   console.log('Añadir');
      this.addCss(
        params.production
          ? params.api.mj + 'scss/append.css'
          : 'assets/scss/append.css'
      );
    }
  }

  addCss(ref) {
    const file = location.pathname.split('/').pop();
    const link = document.createElement('link');
    link.href = file.substr(0, file.lastIndexOf('.')) + ref;
    link.type = 'text/css';
    link.rel = 'stylesheet';
    link.media = 'screen,print';
    document.getElementsByTagName('head')[0].appendChild(link);
  }

  /**
   * @description Oculta todos los console.log por default, se deben activar manualmente (Solamente en productivo)
   */
  developerMode() {
    let _logDev;
    let _log = console.log;
    window._logDev = console.log;
    window.enableDev = function () {
      window.console.log = function (logMessage) {
        window._logDev.apply(console, arguments);
      };
    };

    window.console.log = function (logMessage) {
      if (!(<any>params).production) {
        _log.apply(console, arguments);
      }
    };
  }
}
